export const BRONTO_CONTACT_EID = 'bronto_contact_eid';
export const BRONTO_MAGENTO_ID = 'bronto_magento_id';
export const BRONTO_BADGES = {
    '71': 'New',
    '131': 'Clearance',
    '127': 'Premium Frames',
};

export const BRONTO_ID = '_bta_tid';
export const BRONTO_TID = 'bronto_tid';
